import { useState } from 'react';

export type TagInputProps = {
  name: string;
  defaultValue: string | number | number[] | null;
  onChange?: (value: string) => void;
  disabled?: boolean | undefined;
  required?: boolean | undefined;
};

export const TagInput = ({ name, defaultValue, onChange, disabled, required }: TagInputProps) => {
  const [tags, setTags] = useState<string[]>(defaultValue ? defaultValue.toString().split(',') : []);

  function updateFieldValue(list) {
    onChange(list.join(','));
  }

  function handleKeyDown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();

      const value = event.target.value;

      if (value && tags.indexOf(value) === -1) {
        const list = [...tags, ...[value]];

        setTags(list);
        updateFieldValue(list);
      }

      // clear input
      event.target.value = '';
    }
  }

  function handleBlur(event) {
    const value = event.target.value.trim();

    if (value && tags.indexOf(value) === -1) {
      const list = [...tags, ...[value]];

      setTags(list);
      updateFieldValue(list);

      // clear input
      event.target.value = '';
    }
  }

  function removeSelectedItem(tag: string) {
    const list = tags.filter(item => tag !== item);
    setTags(list);
    updateFieldValue(list);
  }

  return (
    <div className="w-[592px]">
      <div className="flex flex-col gap-1">
        <div className="shadow-sm bg-white inline-flex gap-2 items-center flex-wrap p-1.5 border border-solid">
          {tags.map((tag, index) => {
            return (
              <span
                className="bg-gray-200 rounded-md py-1 px-2 focus:bg-red-400 text-sm"
                key={`selected-item-${index}`}
              >
                {tag}
                <span
                  className="pl-2 cursor-pointer border"
                  onClick={e => {
                    e.stopPropagation();
                    removeSelectedItem(tag);
                  }}
                >
                  &#10005;
                </span>
              </span>
            );
          })}
          <input
            type="text"
            name={name}
            className="form-control"
            onKeyDown={handleKeyDown}
            onBlur={handleBlur}
            disabled={disabled}
            required={required}
          />
        </div>
      </div>
    </div>
  );
};

export default TagInput;
